export default __webpack_public_path__ + "static/media/debit@2x.68fc98c4.png";